import ActionComment from './action-comment/action-comment.container'
// import ActionJoin from './action-join/action-join.container'
// import ActionInvitation from './action-invitation/action-invitation.container'
import ActionConclusion from './action-conclusion/action-conclusion.container'
import ActionUnmarkConclusion from './action-unmark-conclusion/action-unmark-conclusion.container'
import ActionAddWork from './action-add-work/action-add-work.container'
import ActionRemoveWork from './action-remove-work/action-remove-work.container'

const actionMap = {
  CommentAdded: ActionComment,
  CommentAddedWithAttachment: ActionComment,
  // AccountJoinedDiscussion: ActionJoin,
  // GuestModeratorInvited: ActionInvitation,
  ContributionMarkedAsConclusion: ActionConclusion,
  ContributionUnmarkedAsConclusion: ActionUnmarkConclusion,
  WorkAdded: ActionAddWork,
  WorkRemoved: ActionRemoveWork
}

export default actionMap
